<script setup>
import { defineProps } from "vue";

defineProps({
  sectionName: String,
});
</script>

<template>
  <div>
    <div
      class="main-content"
      :style="{
        'background-image':
          'url(' +
          require('../assets/images/' +
            sectionName +
            '/' +
            sectionName +
            '.jpg') +
          ')',
      }"
    >
      <div
        class="d-flex position-relative h-100 flex-column justify-content-center main-box align-items-end shadow fix-card-main"
      >
        <div class="bg-white p-4 main-card rounded-4">
          <p class="fw-bold text-size-28">¿Buscas plomeros de alta calidad?</p>
          <p class="text-size-22">
            En Plomeros a tu Alcance, llevamos la solución a tu puerta
          </p>
          <p class="text-size-22">
            Estamos aquí para hacer que tus preocupaciones desaparezcan.
          </p>
          <div class="w-100">
            <a
              href="https://wa.link/znv6wi"
              class="btn btn-easy-green fw-bold d-block px-4 py-2 shadow text-size-20 mt-2 rounded"
              >!Contactar ahora!</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainComponent",
};
</script>
